import React, { useRef, useEffect } from "react";
import MapView, { Circle, Marker, Region } from "react-native-maps";

import { colors } from "assets/constants";
import { mq } from "utils";
import { StyleSheet, TouchableOpacity } from "react-native";

const latitudeDelta = 0.002;
const longitudeDelta = 0.0005;

export default function MapViewBox(props: {
  coordinate: { lat: string; lng: string };
  onPress: () => void;
}) {
  const { onPress, coordinate } = props;

  const mapRef = useRef<MapView>(null);

  const location: Region = {
    latitude: +coordinate.lat,
    longitude: +coordinate.lng,
    latitudeDelta,
    longitudeDelta,
  };

  useEffect(() => {
    mapRef.current?.animateToRegion({
      latitude: +coordinate.lat,
      longitude: +coordinate.lng,
      latitudeDelta,
      longitudeDelta,
    });
  }, [coordinate]);

  return (
    <>
      <MapView
        ref={mapRef}
        initialRegion={location}
        scrollEnabled={false}
        zoomEnabled={false}
        rotateEnabled={false}
        style={styles.mapView}
      >
        <Circle
          center={location}
          radius={100}
          strokeWidth={2}
          strokeColor={colors.info}
          fillColor={`${colors.blue}33`}
        />
        <Marker coordinate={location} />
      </MapView>
      <TouchableOpacity
        activeOpacity={1}
        onPress={onPress}
        style={{ ...styles.mapView, zIndex: mq(1000) }}
      />
    </>
  );
}

const styles = StyleSheet.create({
  mapView: {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: mq(0),
    left: mq(0),
    right: mq(0),
    bottom: mq(0),
    borderWidth: 1,
    marginBottom: mq(0),
    borderRadius: mq(5),
    borderColor: colors.placeholder,
  },
});
